<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      visible
      direction="rtl"
      :size="1200"
      :before-close="() => cancel()"
      @close="close()"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :quotationCode="quotationCode"
          @checkbox-change="(r) => (checkedRow = r)"
        />
      </div>
      <div class="drawer-footer">
        <el-button size="small" @click="cancel()">
          {{ this.$l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-badge :value="checkedCount" :hidden="!checkedCount" class="ml-2">
          <el-button
            type="primary"
            size="small"
            :disabled="!checkedCount"
            @click="confirm()"
          >
            {{ $l('INDEX.btn_confirm') || '确定' }}
          </el-button>
        </el-badge>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    quotationCode: { type: String, default: '' },
    custName: { type: String, default: '' },
  },
  data() {
    return { checkedRow: [] }
  },
  computed: {
    checkedCount() {
      return this.checkedRow?.length || 0
    },
    title() {
      return [
        this.custName,
        this.$l('dialog_title_addProduct') || '客户报价记录',
      ]
        .filter(Boolean)
        .join(' ')
    },
  },
  methods: {
    async confirm() {
      if (!this.checkedCount) return this.close()

      const listDevTrackingQuotationCode = this.checkedRow.map(
        (row) => row.devTrackingQuotationCode
      )

      if (this.loadingOpen()) return
      const res = await this.$api
        .customerQuotationSampleAddApi({
          quotationCode: this.quotationCode,
          listDevTrackingQuotationCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    async cancel() {
      if (!this.checkedCount) return this.close()

      const confirm = await this.$confirm(
        this.$l('tips_addProduct_cancel') || '是否确认放弃选中的报价产品？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      this.close()
    },
    close() {
      this.checkedRow = []
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style lang="scss" scoped>
.drawer-main {
  padding: 0 10px 20px;
}
.drawer-footer {
  padding: 10px 10px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
